// The pay components that compose the SSS contribution basis
// (PRD_SssContributionBasis C3). ONE source for the labels: the Pay Rates
// settings card renders them, and the Deductions-step derivation popover must
// show the SAME strings exactly (C22) — so neither file spells them itself.
//
// `alwaysOn` marks basic pay: it is ALWAYS part of the basis and is not offered
// as a choice (C2, revised at /test-impl). The settings card filters these out
// of its checkbox list; the popover still needs the entry for its LABEL, which
// is why the factor stays here rather than being deleted.
//
// Keys mirror the engine's own component fields (earnings.basic … deductions.absence)
// and DEFAULT_SSS_BASIS.factors in functions/src/payroll/constants.js; a test pins
// the two key sets identical (C19).
export const SSS_BASIS_FACTORS = [
  { key: "basic", label: "Basic pay", sign: "add", alwaysOn: true },
  { key: "overtime", label: "Overtime", sign: "add" },
  { key: "nightDiff", label: "Night differential", sign: "add" },
  { key: "holiday", label: "Holiday pay", sign: "add" },
  { key: "restDay", label: "Rest day premium", sign: "add" },
  { key: "undertime", label: "Undertime", sign: "subtract" },
  { key: "absence", label: "Absence", sign: "subtract" },
];
